module.exports = __webpack_public_path__ + "img/ubuntu.e686e4b8.svg";